/**
 * Photo key (backlog, user rule: never freeze the run): `P` exports a
 * still of the live spectacle. The WebGL canvas holds only the scene (the
 * HUD is DOM), so a capture is already clean; the scene is re-rendered
 * immediately before reading the canvas because the default framebuffer
 * is not preserved between frames (preserveDrawingBuffer: false).
 */
import type { SceneCtx } from "./scene.ts";

export interface PhotoKey {
  /** Shots taken this session (CUA/tests). */
  readonly count: number;
  dispose(): void;
}

export function installPhotoKey(
  ctx: SceneCtx,
  filename: () => string,
): PhotoKey {
  let count = 0;
  const onKey = (ev: KeyboardEvent) => {
    if (ev.key !== "p" && ev.key !== "P") return;
    ctx.renderer.render(ctx.scene, ctx.camera);
    ctx.renderer.domElement.toBlob((blob: Blob | null) => {
      if (!blob) return;
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `${filename()}.png`;
      a.click();
      URL.revokeObjectURL(a.href);
    }, "image/png");
    count++;
  };
  addEventListener("keydown", onKey);
  return {
    get count() {
      return count;
    },
    dispose() {
      removeEventListener("keydown", onKey);
    },
  };
}
